'use strict';

/**
 * The name of events that wqe fire to different analytics platforms.
 * Each one is mapped to platform specific event name.
 * Used in Webapp primarily. Used in CT for customisation of pages in Webapp (to decide which event to fire when and where).
 */
var ANALYTICS_EVENTS = {
    PAGE_VIEW: "PageView",
    CONTACT: "Contact",
    LEAD: "Lead",
    ADD_TO_CART: "AddToCart",
    INITIATE_CHECKOUT: "InitiateCheckout",
    ADD_PAYMENT_INFO: "AddPaymentInfo",
    PURCHASE: "Purchase",
    SALE_PAGE_REGISTER_CTA_CLICK: "SalePageRegisterCtaClick",
};

exports.ANALYTICS_EVENTS = ANALYTICS_EVENTS;
//# sourceMappingURL=events.js.map
